import { FormattedMessage } from 'react-intl';
import { IconDashboard, IconDeviceAnalytics } from '@tabler/icons';

const icons = {
	IconDashboard,
	IconDeviceAnalytics,
};

const LandedCost = {
	id: 'costs',
	title: <FormattedMessage id="landed-cost" />,
	icon: icons.IconDashboard,
	type: 'group',
	children: [
		{
			id: 'winners',
			title: <FormattedMessage id="landed-cost-winners" />,
			type: 'item',
			url: '/landed-cost/Winners',
			icon: WinnersIcon,
			breadcrumbs: false,
		},
		// {
		// 	id: 'dailyCost',
		// 	title: <FormattedMessage id="landed-cost-daily-cost" />,
		// 	type: 'item',
		// 	url: '/landed-cost/DailyCost',
		// 	icon: DailyIcon,
		// 	breadcrumbs: false,
		// },
		// {
		// 	id: 'loadEntry',
		// 	title: <FormattedMessage id="landed-cost-load-entry" />,
		// 	type: 'item',
		// 	url: '/landed-cost/LoadEntry',
		// 	icon: EntryIcon,
		// 	breadcrumbs: false,
		// },
		{
			id: 'loadEntries',
			title: <FormattedMessage id="landed-cost-load-entries" />,
			type: 'item',
			url: '/landed-cost/LoadEntries',
			icon: EntriesIcon,
			breadcrumbs: false,
		},
	],
};

export default LandedCost;

function EntryIcon() {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<title>entry</title>

			<path
				d="M21.41 11.58L12.41 2.58C12.04 2.21 11.53 2 11 2H4C3.46957 2 2.96086 2.21071 2.58579 2.58579C2.21071 2.96086 2 3.46957 2 4V11C2 11.53 2.21 12.04 2.59 12.41L3 12.81C3.9 12.27 4.94 12 6 12C7.5913 12 9.11742 12.6321 10.2426 13.7574C11.3679 14.8826 12 16.4087 12 18C12 19.06 11.72 20.09 11.18 21L11.58 21.4C11.95 21.78 12.47 22 13 22C13.53 22 14.04 21.79 14.41 21.41L21.41 14.41C21.79 14.04 22 13.53 22 13C22 12.47 21.79 11.96 21.41 11.58ZM5.5 7C5.10218 7 4.72064 6.84196 4.43934 6.56066C4.15804 6.27936 4 5.89782 4 5.5C4 5.10218 4.15804 4.72064 4.43934 4.43934C4.72064 4.15804 5.10218 4 5.5 4C5.89782 4 6.27936 4.15804 6.56066 4.43934C6.84196 4.72064 7 5.10218 7 5.5C7 5.89782 6.84196 6.27936 6.56066 6.56066C6.27936 6.84196 5.89782 7 5.5 7ZM10 19H7V22H5V19H2V17H5V14H7V17H10V19Z"
				fill="currentColor"
			/>
		</svg>
	);
}

function EntriesIcon() {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<title>entries</title>

			<path
				d="M11 2H2V11H11V2ZM22 2H13V11H22V2ZM11 13H2V22H11V13ZM18.5 13H16.5V16.5H13V18.5H16.5V22H18.5V18.5H22V16.5H18.5V13Z"
				fill="currentColor"
			/>
		</svg>
	);
}

function WinnersIcon() {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<title>winners</title>

			<path
				d="M19.5 3.75C19.4994 3.15345 19.2621 2.58152 18.8403 2.1597C18.4185 1.73787 17.8465 1.50062 17.25 1.5H6.75C6.15345 1.50062 5.58152 1.73787 5.1597 2.1597C4.73787 2.58152 4.50062 3.15345 4.5 3.75V20.25C4.50062 20.8465 4.73787 21.4185 5.1597 21.8403C5.58152 22.2621 6.15345 22.4994 6.75 22.5H17.25C17.8465 22.4994 18.4185 22.2621 18.8403 21.8403C19.2621 21.4185 19.4994 20.8465 19.5 20.25V3.75ZM7.875 20.25C7.6525 20.25 7.43499 20.184 7.24998 20.0604C7.06498 19.9368 6.92078 19.7611 6.83564 19.5555C6.75049 19.35 6.72821 19.1238 6.77162 18.9055C6.81502 18.6873 6.92217 18.4868 7.0795 18.3295C7.23684 18.1722 7.43729 18.065 7.65552 18.0216C7.87375 17.9782 8.09995 18.0005 8.30552 18.0856C8.51109 18.1708 8.68679 18.315 8.8104 18.5C8.93402 18.685 9 18.9025 9 19.125C9 19.4234 8.88147 19.7095 8.6705 19.9205C8.45952 20.1315 8.17337 20.25 7.875 20.25ZM7.875 16.5C7.6525 16.5 7.43499 16.434 7.24998 16.3104C7.06498 16.1868 6.92078 16.0111 6.83564 15.8055C6.75049 15.6 6.72821 15.3738 6.77162 15.1555C6.81502 14.9373 6.92217 14.7368 7.0795 14.5795C7.23684 14.4222 7.43729 14.315 7.65552 14.2716C7.87375 14.2282 8.09995 14.2505 8.30552 14.3356C8.51109 14.4208 8.68679 14.565 8.8104 14.75C8.93402 14.935 9 15.1525 9 15.375C9 15.6734 8.88147 15.9595 8.6705 16.1705C8.45952 16.3815 8.17337 16.5 7.875 16.5ZM7.875 12.75C7.6525 12.75 7.43499 12.684 7.24998 12.5604C7.06498 12.4368 6.92078 12.2611 6.83564 12.0555C6.75049 11.85 6.72821 11.6238 6.77162 11.4055C6.81502 11.1873 6.92217 10.9868 7.0795 10.8295C7.23684 10.6722 7.43729 10.565 7.65552 10.5216C7.87375 10.4782 8.09995 10.5005 8.30552 10.5856C8.51109 10.6708 8.68679 10.815 8.8104 11C8.93402 11.185 9 11.4025 9 11.625C9 11.9234 8.88147 12.2095 8.6705 12.4205C8.45952 12.6315 8.17337 12.75 7.875 12.75ZM12 20.25C11.7775 20.25 11.56 20.184 11.375 20.0604C11.19 19.9368 11.0458 19.7611 10.9606 19.5555C10.8755 19.35 10.8532 19.1238 10.8966 18.9055C10.94 18.6873 11.0472 18.4868 11.2045 18.3295C11.3618 18.1722 11.5623 18.065 11.7805 18.0216C11.9988 17.9782 12.225 18.0005 12.4305 18.0856C12.6361 18.1708 12.8118 18.315 12.9354 18.5C13.059 18.685 13.125 18.9025 13.125 19.125C13.125 19.4234 13.0065 19.7095 12.7955 19.9205C12.5845 20.1315 12.2984 20.25 12 20.25ZM12 16.5C11.7775 16.5 11.56 16.434 11.375 16.3104C11.19 16.1868 11.0458 16.0111 10.9606 15.8055C10.8755 15.6 10.8532 15.3738 10.8966 15.1555C10.94 14.9373 11.0472 14.7368 11.2045 14.5795C11.3618 14.4222 11.5623 14.315 11.7805 14.2716C11.9988 14.2282 12.225 14.2505 12.4305 14.3356C12.6361 14.4208 12.8118 14.565 12.9354 14.75C13.059 14.935 13.125 15.1525 13.125 15.375C13.125 15.6734 13.0065 15.9595 12.7955 16.1705C12.5845 16.3815 12.2984 16.5 12 16.5ZM12 12.75C11.7775 12.75 11.56 12.684 11.375 12.5604C11.19 12.4368 11.0458 12.2611 10.9606 12.0555C10.8755 11.85 10.8532 11.6238 10.8966 11.4055C10.94 11.1873 11.0472 10.9868 11.2045 10.8295C11.3618 10.6722 11.5623 10.565 11.7805 10.5216C11.9988 10.4782 12.225 10.5005 12.4305 10.5856C12.6361 10.6708 12.8118 10.815 12.9354 11C13.059 11.185 13.125 11.4025 13.125 11.625C13.125 11.9234 13.0065 12.2095 12.7955 12.4205C12.5845 12.6315 12.2984 12.75 12 12.75ZM17.25 19.125C17.25 19.4234 17.1315 19.7095 16.9205 19.9205C16.7095 20.1315 16.4234 20.25 16.125 20.25C15.8266 20.25 15.5405 20.1315 15.3295 19.9205C15.1185 19.7095 15 19.4234 15 19.125V15.375C15 15.0766 15.1185 14.7905 15.3295 14.5795C15.5405 14.3685 15.8266 14.25 16.125 14.25C16.4234 14.25 16.7095 14.3685 16.9205 14.5795C17.1315 14.7905 17.25 15.0766 17.25 15.375V19.125ZM16.125 12.75C15.9025 12.75 15.685 12.684 15.5 12.5604C15.315 12.4368 15.1708 12.2611 15.0856 12.0555C15.0005 11.85 14.9782 11.6238 15.0216 11.4055C15.065 11.1873 15.1722 10.9868 15.3295 10.8295C15.4868 10.6722 15.6873 10.565 15.9055 10.5216C16.1238 10.4782 16.35 10.5005 16.5555 10.5856C16.7611 10.6708 16.9368 10.815 17.0604 11C17.184 11.185 17.25 11.4025 17.25 11.625C17.25 11.9234 17.1315 12.2095 16.9205 12.4205C16.7095 12.6315 16.4234 12.75 16.125 12.75ZM17.0302 8.03016C16.8896 8.17083 16.6989 8.24991 16.5 8.25H7.5C7.30109 8.25 7.11032 8.17098 6.96967 8.03033C6.82902 7.88968 6.75 7.69891 6.75 7.5V4.5C6.75 4.30109 6.82902 4.11032 6.96967 3.96967C7.11032 3.82902 7.30109 3.75 7.5 3.75H16.5C16.6989 3.75 16.8897 3.82902 17.0303 3.96967C17.171 4.11032 17.25 4.30109 17.25 4.5V7.5C17.2499 7.69888 17.1708 7.88958 17.0302 8.03016Z"
				fill="currentColor"
			/>
		</svg>
	);
}

function DailyIcon() {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<title>daily</title>

			<g clipPath="url(#clip0_289_1869)">
				<path
					d="M16.8948 0.947388V4.73686H20.6842L16.8948 0.947388Z"
					fill="currentColor"
				/>
				<path
					d="M15 6.63159V0H3.94739V8.21053H14.3685V22.7369H21.6316V6.63159H15Z"
					fill="currentColor"
				/>
				<path
					d="M2.36841 10.1053V24H12.4737V10.1053H2.36841ZM6.47367 21.7895H4.57894V19.8947H6.47367V21.7895ZM6.47367 18H4.57894V16.1053H6.47367V18ZM10.2631 21.7895H8.36841V19.8947H10.2631V21.7895ZM10.2631 18H8.36841V16.1053H10.2631V18ZM10.2631 14.2105H4.57894V12.3158H10.2631V14.2105Z"
					fill="currentColor"
				/>
			</g>
			<defs>
				<clipPath id="clip0_289_1869">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}
